import { Injectable } from '@angular/core';
import {
  LicensePlateItemResponseModel,
  LicensePlateResponseModel,
} from '../models/response-models/license-plate-response.model';

@Injectable({
  providedIn: 'root',
})
export class LpItemsQuantityService {
  getLicensePlateItemsQuantity(LicensePlate: LicensePlateResponseModel | null): number {
    return (LicensePlate?.items ?? []).reduce(
      (total: number, item: LicensePlateItemResponseModel) =>
        total + (item.isItemSerialized ? (item.itemSerials?.length ?? 0) : (item.quantity ?? 0)),
      0,
    );
  }

  getTotalQuantityFromItems(items: any[]): number {
    let total = 0;

    for (const item of items) {
      if (item.licensePlate) {
        total += this.getLicensePlateItemsQuantity(item.licensePlate);
      }
    }

    return total;
  }

  getTotalSkuFromItems(items: any[]): number {
    const skuSet = new Set<number>();

    for (const item of items) {
      const lp = item.licensePlate;

      if (lp?.items) {
        for (const lpItem of lp.items) {
          skuSet.add(lpItem.productId);
        }
      }
    }

    return skuSet.size;
  }
}
